<template>
  <div id="register">

    <mt-header title="注册" style="height: 50px">
      <router-link to="/" slot="left">
        <mt-button>
          <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
        </mt-button>
      </router-link>
    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>

    <div class="register-content">
      <div class="textfield-view">
        <input type="text"
               style="color:#191919"
               v-model="phontNum"
               placeholder="手机号码"
               @blur="phonteBlurEvent"
               class="textfield"/>
        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="textfield-view">
        <input type="password"
               style="color:#191919;"
               v-model="password"
               placeholder="设置8-20位密码"
               class="textfield"/>


        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="textfield-view">
        <input type="password"
               style="color:#191919"
               v-model="passwordAgain"
               placeholder="重复密码"
               class="textfield"/>
        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="textfield-view textfield-view2">
        <span class="textfield-view2-left">
          <input type="text"
                 style="color:#191919"
                 v-model="sms"
                 placeholder="短信验证码"
                 @input="" class="textfield"/>
          <hr style="height: 1px;background-color: #666666;"/>
        </span>
        <span v-bind:class="codeBtnClass" @click="getCode">
          {{codeBtnValue}}
        </span>


      </div>

      <div class="button" @click="registerEvent">
        注册
      </div>

      <div class="register-footer">

        <span>用户注册即代表同意</span>
        <router-link to="/userAgreement">
          <span style="color: #bd8d46">&nbsp&nbsp&nbsp&nbsp《用户协议》</span>
        </router-link>

      </div>
    </div>


  </div>
</template>

<script>
  //  import { MessageBox } from 'mint-ui'
  import api from '../../../api/common/api.common'
  export default {
    name: 'register',
    mounted () {
    },
    destroyed () {
    },
    computed: {
    },
    data () {
      return {
        codeBtnValue: '获取验证码',
        codeBtnClass: 'textfield-view2-right',
        phontNum: '',
        password: '',
        passwordAgain: '',
        sms: ''
      }
    },
    methods: {
      phonteBlurEvent () {
        var data = this.phontNum
        var self = this
        api.getIsRegist(data,function (respond) {
          if (respond.body.data.register === true) {
            self.utils.alert('该手机号已注册')
          }
        })
      },
      getCode (sender) {
        if (!this.utils.isMobileNum(this.phontNum)) {
          this.utils.alert('请填写正确的手机号')
          return
        }

        var self = this
        var data = {}
        data.mobilePhone = this.phontNum
        data.verifyCodeType = 3
        api.getAuthCode(data,function () {
          let sec =60;
          self.codeBtnClass = 'textfield-view2-right codeBtn-disabled'
          for(let  i=0; i<=60; i++){
            window.setTimeout(function(){
              if (sec != 0) {
                self.codeBtnValue =   sec + "秒" ;
                sec--;
              } else {
                sec = 60;//如果倒计时结束就让  获取验证码显示出来
                self.codeBtnValue = '获取验证码'
                self.codeBtnClass = 'textfield-view2-right'
              }
            }, i * 1000)
          }
        })
      },
      registerEvent () {
        if (!this.utils.isMobileNum(this.phontNum)) {
          this.utils.alert('请填写正确的手机号')
          return
        }

        if (this.password.length < 8
          || this.password.length > 20
          || (/^\d*$/.test(this.password))
          || (/^[a-z]*$/i.test(this.password))
          || !(/^[a-z\d]*$/i.test(this.password))) {
          this.utils.alert('密码必须是包含字母和数字的8-20位字符')
          return
        }

        if (this.password !== this.passwordAgain) {
          this.utils.alert('密码输入不一致')
          return
        }

        if (this.sms.length > 6 || this.sms.length === 0) {
          this.utils.alert('验证码输入错误')
          return
        }

        var data = {}
        data.mobilePhone = this.phontNum
        data.password = this.password
        data.registerType = 0
        data.repeatPassword = this.passwordAgain
        data.verifyCode = this.sms


        var self = this
        api.register(data,function (successRespond) {
          self.utils.alert('注册成功')
          localStorage.setItem('userIsLogin', true);
          localStorage.setItem('userloginTime', new Date());
          localStorage.setItem('loginCredentials', successRespond.body.data['loginCredentials']);
          self.$router.push({path: '/'})
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';


  .register-content {
    margin-top: pxToRem(60px);
  }

  .textfield-view {

    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
  }
  .textfield-view2 {
    display: flex;
    justify-content: space-between;
  }
  .textfield-view2-left {
    width: pxToRem(416px);
  }
  .textfield-view2-right {
    width: pxToRem(180px);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: pxToRem(43px);
    border:solid 1px  #191919;
  }


  .textfield {
    margin-top: pxToRem(60px);
    margin-bottom: pxToRem(30px);
    width: 100%;
  }
  .button {
    background: #3D2D23;
    height: pxToRem(100px);
    line-height: pxToRem(100px);
    text-align: center;
    color: white;
    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
    margin-top: pxToRem(80px);
    font-size: pxToRem(28px);
  }
  .register-footer {
    display: flex;
    justify-content: flex-start;
    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
    margin-top: pxToRem(60px);
    color: #666666;
    font-size: pxToRem(22px);
  }

  .codeBtn-disabled {
    pointer-events: none;
    cursor: default;
    opacity: 0.6;
  }
</style>


// WEBPACK FOOTER //
// register.vue?6149f73c